import React from 'react'
import { VendorEvaluationCycleStatus } from '@trustero/trustero-api-web/lib/vendormanagement/vendor_evaluation_cycle_pb'
import { STATUS_PILLS } from 'src/pages/Vendors/evaluations/evaluationPills'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

// A vendor's latest evaluation status, by the status number the vendor list
// filters on; "Not evaluated" is UNSPECIFIED.
const EVALUATION_FILTER_VALUES = [
  {
    value: `${VendorEvaluationCycleStatus.VENDOR_EVALUATION_CYCLE_STATUS_UNSPECIFIED}`,
    label: 'Not evaluated',
  },
  ...Object.entries(STATUS_PILLS).map(([status, { label }]) => ({
    value: status,
    label,
  })),
]

export const VendorEvaluationFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <FilterDropdown
      filterParam={FilterParam.VENDOR_EVALUATION}
      filterName={FilterName.VENDOR_EVALUATION}
      filterValues={EVALUATION_FILTER_VALUES}
      isNested={isNested}
    />
  ),
)
